import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/partenaires/backsoft.svg'
import _imports_1 from '@/assets/partenaires/bike-and-go.svg'
import _imports_2 from '@/assets/partenaires/bys-and-kyt.svg'
import _imports_3 from '@/assets/partenaires/color-renovation.svg'
import _imports_4 from '@/assets/partenaires/dupuis-audit-expertise.svg'
import _imports_5 from '@/assets/partenaires/easy-parking.svg'
import _imports_6 from '@/assets/partenaires/immo-confidences.svg'
import _imports_7 from '@/assets/partenaires/institut-nicois-ennour.svg'
import _imports_8 from '@/assets/partenaires/l-entre-deux.svg'
import _imports_9 from '@/assets/partenaires/mathilda-farache.svg'
import _imports_10 from '@/assets/partenaires/one-limousine.svg'
import _imports_11 from '@/assets/partenaires/planet-car-wash.svg'
import _imports_12 from '@/assets/partenaires/planet-clean-services.svg'
import _imports_13 from '@/assets/partenaires/platinium-driver.svg'
import _imports_14 from '@/assets/partenaires/plume.svg'
import _imports_15 from '@/assets/partenaires/thales.svg'


const _hoisted_1 = {
  id: "partners",
  class: "screen"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "intro" }

import CommonShapeAnimation from "@/components/common/CommonShapeAnimation.vue";
import CommonButton from "@/components/common/CommonButton.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";


export default /*@__PURE__*/_defineComponent({
  __name: 'SectionPartenaires',
  setup(__props) {

const clickHandler = (name: string) => {
    trackButtonClick(`partners-header-${name}`);
    scrollToSection(name);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(CommonShapeAnimation, {
      shape: "polygon",
      sides: 5,
      rotation: 10,
      position: "right"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Ils nous font confiance", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, [
            _createElementVNode("strong", null, "Chaque projet est une rencontre, chaque réussite une histoire partagée.")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Parce que chaque marque mérite de briller, nous avons eu l’honneur d’accompagner ces entreprises dans leurs projets. Leur confiance est notre plus grande fierté.", -1)),
          _createElementVNode("a", {
            id: "partners-header-action",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clickHandler('contact'))),
            title: "Contactez-nous"
          }, [
            _createVNode(CommonButton, {
              size: "large",
              icon: "next"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Je me lance", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"w-full\"><div class=\"panel grid-partners\"><a id=\"partners-backsoft\" href=\"https://backsoft.fr\" target=\"_blank\"><img src=\"" + _imports_0 + "\" alt=\"BackSoft - Ingénierie et infrastructures réseau et systèmes\"></a><a id=\"partners-bike-and-go\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_1 + "\" alt=\"Bike &amp; Go - Location de trottinettes Et vélos électriques\"></a><a id=\"partners-bys-kyt\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_2 + "\" alt=\"Bys &amp; Kyt - Agence digitale\"></a><a id=\"partners-color-renovation\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_3 + "\" alt=\"Color Rénovation - Menuiserie, serrurerie, stores\"></a><a id=\"partners-dupuis\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_4 + "\" alt=\"Dupuis Audit Expertise - Expertise comptable\"></a><a id=\"partners-easy-parking\" href=\"https://easy-parking.com\" target=\"_blank\"><img src=\"" + _imports_5 + "\" alt=\"Easy Parking\"></a><a id=\"partners-immo-confidences\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_6 + "\" alt=\"Immo Confidences\"></a><a id=\"partners-institut-ennour\" href=\"https://en-nour.org/\" target=\"_blank\"><img src=\"" + _imports_7 + "\" alt=\"Institut Niçois Ennour\"></a><a id=\"partners-entre-deux\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_8 + "\" alt=\"L&#39;entre deux\"></a><a id=\"partners-mathilda-farache\" href=\"https://mathildafarache.fr/\" target=\"_blank\"><img src=\"" + _imports_9 + "\" alt=\"Mathilda Farache - Sophrologue\"></a><a id=\"partners-one-limousine\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_10 + "\" alt=\"One Limousine - Chaffeur privé\"></a><a id=\"partners-planet-car-wash\" href=\"https://planetcarwash.fr\" target=\"_blank\"><img src=\"" + _imports_11 + "\" alt=\"Planet Car Wash - Le spécialiste du lavage auto écologique à Nice et dans les Alpes-Maritimes.\"></a><a id=\"partners-planet-clean-services\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_12 + "\" alt=\"\"></a><a id=\"partners-platinium-driver\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_13 + "\" alt=\"Platinium Driver - Chaffeur privé\"></a><a id=\"partners-plume\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_14 + "\" alt=\"Plume - Relaxologie &amp; Reïki\"></a><a id=\"partners-association-thales\" href=\"#\" target=\"_blank\"><img src=\"" + _imports_15 + "\" alt=\"Association Thales\"></a></div></div>", 1))
      ])
    ])
  ]))
}
}

})